import React from 'react';

const BulletList = ({ items }) => (
  <ul className="legal-bullet-list">
    {items.map((item) => (
      <li key={item}>{item}</li>
    ))}
  </ul>
);

export default BulletList;
